import { GridFilterModel } from '@mui/x-data-grid';

export function parseFilterModel(filterModel: GridFilterModel) {
    const conditions: unknown[] = [];

    filterModel.items.forEach((item) => {
        const field = item.field;
        const operator = item.operator;
        const value = item.value;
        switch (field) {
            case 'startTime':
                conditions.push({
                    startTime: {
                        [item.operator === 'gte' ? 'gte' : 'lte']: new Date(item.value),
                    },
                });
                break;
            case 'endTime':
                conditions.push({
                    startTime: {
                        [item.operator === 'gte' ? 'gte' : 'lte']: new Date(item.value),
                    },
                });
                break;
            case 'lessonName':
                conditions.push({
                    lessonVersion: {
                        lessonName: {
                            [operator]: value,
                        },
                    },
                });
                break;
            case 'homeworkName':
                conditions.push({
                    homeworkName: {
                        [operator]: value,
                    },
                });
                break;
        }
    });

    return conditions;
}
